export default __webpack_public_path__ + "static/media/splashart1.7d1a9bc5.webp";